import SideMenu from './SideMenu';
import { connect } from '../../node_modules/react-redux';
import { clearToken as _clearToken } from '../../state/actions/auth';
import { ONBOARDING_FLOWS } from '../../utils/onboarding';
import { TUTORIAL_NAME } from '../../utils/tutorial';
import { setActiveGameRoom as _setActiveGameRoom } from '../../state/slices/gameRooms/gameRooms';
import { setOnboardingHighlightedPosition as _setOnboardingHighlightedPosition, setOnboardingStep as _setOnboardingStep } from '../../state/actions/currentOnboarding';
var mapStateToProps = function mapStateToProps(state) {
  return {
    userCanFavourite: parseInt(state.levelInfo.level) >= parseInt(state.ftue.onboardingsUnlockLevels[ONBOARDING_FLOWS.FAVOURITES]),
    navState: state.navState.navState,
    sidebarState: state.sidebarState.sidebarState,
    isVipRoomUnlocked: state.consumables.isVipRoomUnlocked,
    isAccountLinked: state.playerInfo.isAccountLinked === 'yes',
    sportsGamesRoom: state.sportsGames,
    isBlockedForMissionsTutorial: state.tutorial.blockLobby && state.tutorial.tutorialName === TUTORIAL_NAME.MISSIONS_TUTORIAL,
    gameRooms: state.gameRooms.data,
    activeGameRoom: state.gameRooms.activeGameRoom,
    onboardingStep: state.currentOnboarding.currentStep
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    clearToken: function clearToken() {
      dispatch(_clearToken(true));
    },
    setActiveGameRoom: function setActiveGameRoom(value) {
      dispatch(_setActiveGameRoom(value));
    },
    setOnboardingHighlightedPosition: function setOnboardingHighlightedPosition(value) {
      dispatch(_setOnboardingHighlightedPosition(value));
    },
    setOnboardingStep: function setOnboardingStep(value) {
      dispatch(_setOnboardingStep(value));
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SideMenu);